import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { apiAxios } from "../../../../utils/apiAxios";
import { TableColumn } from "react-data-table-component";
import { TicketTypeRow } from "../Interfaces/TicketTypeRow";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

const TicketType = () => {

  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [ticketType, setTicketType] = useState("");
  const [editId, setEditId] = useState(null);
  const [data, setData] = useState<TicketTypeRow[]>([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);
  // ✅ GET ALL
  const getTicketTypes = async () => {
    try {
      const res = await apiAxios.get(`${API_BASE}/TicketType/GetAll`);

      // 🔥 IMPORTANT: ResponseDto structure
      const list = res.data.data || [];

      const mapped = list.map((x: { id: any; ticketTypeName: any; }) => ({
        id: x.id,
        ticketType: x.ticketTypeName
      }));

      setData(mapped);

    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    getTicketTypes();
  }, []);

  // ✅ ADD / UPDATE
  const handleSubmit = async () => {
    if (!ticketType) {
      toast.error("Enter Ticket Type");
      return;
    }

    try {

      if (editId) {
        const res = await apiAxios.put(`${API_BASE}/TicketType/Update/${editId}`, {
          ticketTypeName: ticketType
        });

        toast.success(res.data.status || "Updated Successfully");
      } else {
        const res = await apiAxios.post(`${API_BASE}/TicketType/Create`, {
          ticketTypeName: ticketType
        });

        toast.success(res.data.status || "Created Successfully");
      }

      setTicketType("");
      setEditId(null);
      getTicketTypes();

    } catch (error: any) {
      console.error("Save error:", error);

      const apiError = error?.response?.data;

      if (apiError?.errors?.length) {
        toast.error(apiError.errors[0]); // 🔥 duplicate message here
      } else {
        toast.error(apiError?.status || "Something went wrong");
      }
    }
  };

  // ✅ EDIT
  const handleEdit = (row: { id: any; ticketType?: any; }) => {
    setTicketType(row.ticketType);
    setEditId(row.id);
  };


  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };


  // ✅ DELETE
  //  const handleDelete = async (id: any) => {
  //   if (!window.confirm("Delete this record?")) return;

  //   try {
  //     const res = await apiAxios.delete(`${API_BASE}/TicketType/Delete/${id}`);

  //     toast.success(res.data.message || "Deleted Successfully");

  //     getTicketTypes();
  //   } catch (error: any) {
  //     toast.error(
  //       error?.response?.data?.message || "Delete failed"
  //     );
  //   }
  // };
  const handleDelete = async () => {
    if (deleteId === null) return;

    try {
      const res = await apiAxios.delete(
        `${API_BASE}/TicketType/Delete/${deleteId}`
      );

      toast.success(res.data.message || "Deleted Successfully");

      setData(prev => prev.filter(item => item.id !== deleteId));

    } catch (error: any) {
      toast.error(
        error?.response?.data?.message || "Delete failed"
      );
    } finally {
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };

  // ✅ COLUMNS
  const columns = [
    {
      name: "ID",
      selector: (row: { id: any; }) => row.id,
      center: true
    },
    {
      name: "Ticket Type",
      selector: (row: { ticketType: any; }) => row.ticketType,
      sortable: true,
      center: true
    },
    {
      name: "Action",
      cell: (row: any) => (
        <div className="d-flex gap-2">
          <button
            onClick={() => handleEdit(row)}
            className="action-btn edit"
          >
            <i className="bi bi-pencil-square"></i>
          </button>

          <button
            onClick={() => confirmDelete(row.id)}
            className="action-btn delete"
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      center: true
    }
  ];

  return (
    <div>

      <h4 className="mb-4">Ticket Type</h4>

      {/* FORM */}
      <div className="premium-card mb-4">
        <div className="row g-3 align-items-end">

          <div className="col-12">
            <label className="form-label">Ticket Type</label>
            <input
              type="text"
              className="form-control"
              value={ticketType}
              onChange={(e) => setTicketType(e.target.value)}
              placeholder="Enter ticket type"
            />
          </div>

          <div className="col-12 col-md-3">
            <button className="btn btn-primary" onClick={handleSubmit}>
              {editId ? "Update" : "Add"}
            </button>
          </div>

        </div>
      </div>

      {/* TABLE */}
      <div className="premium-card">
        <h5 className="mb-3">Ticket Type List</h5>

        <DataTable
          columns={columns}
          data={data}
          pagination
          striped
          highlightOnHover
          responsive
          paginationComponentOptions={{
            noRowsPerPage: true
          }}
        />


      </div>
      {/* ✅ DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Body className="text-center">
          Are you sure you want to delete this ticket type?
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button className="btn btn-primary" onClick={handleDelete}>
            Yes
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => setShowDeleteModal(false)}
          >
            No
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TicketType;